module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('LoadingSpinner', {
    attrs: {
      "showContent": !_vm.isLoading,
      "size": 100
    }
  }, [_c('AppErrorsBlock', {
    staticClass: "mb-4",
    attrs: {
      "errorMessage": _vm.errorMessage,
      "errors": _vm.errors
    }
  }), _c('PurchasesHidePurchaseRequestController'), (_vm.items && _vm.items.length) ? [_vm._l((_vm.items), function(item, index) {
    return _c('PurchaseEventCard', {
      key: item.orderId,
      attrs: {
        "item": item
      },
      on: {
        "cancel": function($event) {
          return _vm.postClose(item)
        },
        "hide": function($event) {
          return _vm.orderHide(item.orderId)
        }
      }
    })
  }), (_vm.pageCount > 1) ? _c('Paginator', {
    attrs: {
      "count": _vm.pageCount,
      "current": _vm.page,
      "max": 6
    }
  }) : _vm._e()] : (!(_vm.items && _vm.items.length) && !_vm.errorMessage && _vm.errors && !_vm.errors.length) ? _c('Warning', {
    attrs: {
      "isHeader": false
    }
  }, [_c('p', [_vm._v("У вас нет ни одной заявки.\nОформив заказ в карточке программы здесь будет информация о сделанных заявках.")])]) : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-04285b9e","hasScoped":false,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/profile/views/purchases/pages/purchases-event/Index.vue
// module id = 9211ba553da27fd13f7c
// module chunks = 2